<section id="main">
  <app-breadcrumbs></app-breadcrumbs>
  <section id="admin-outlet">
    <router-outlet></router-outlet>
  </section>
</section>
